import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { OrganizationsService } from '../../../../core/services/organizations.service';
import { EventService } from '../../../../core/services/event.service';
import { FuseConfigService } from '../../../../core/services/config.service';

@Component({
    selector: 'app-budget',
    templateUrl: './budget.component.html',
    styleUrls: ['./budget.component.scss'],
    standalone: false
})
export class BudgetComponent implements OnInit {
  public filterData: any = {};
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild('sidenav') sidenav: MatSidenav;

  userFilters = false;
  dataSource;
  displayedColumns: string[] = ['date', 'name', 'expenses', 'revenues', 'outlay'];
  currency = 'CHF';
  isOrganizer = false;
  total = 0;
  constructor(private organizationService: OrganizationsService, private eventService: EventService,
              private fuseConfig: FuseConfigService) { }

  ngOnInit() {
    this.eventService.setToAll();
    this.getCountries();
    this.fuseConfig.role.subscribe(res => {
      if (res && res === 'organisationAdmin') {
        this.isOrganizer = true;
        setTimeout(() => {
          this.sidenav.opened = false;
          this.sidenav.close();
        } , 500);
      }
    });
  }

  getCountries () {
    this.organizationService.getCountry().subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.countries = res;
      } else if (res.length === 1) {
        this.getCantons(res[ 0 ].id);
        delete this.filterData.countries;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getCantons (id) {
    this.organizationService.getCity(id).subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.cantonFB = res;
      } else if (res.length === 1) {
        this.eventService.setCities({selected: true , canton: res[ 0 ].id});
        this.getOrganizations();
        delete this.filterData.cantonFB;
      } else {
        delete this.filterData.cantonFB;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getOrganizations () {
    this.eventService.getOrganizationByCantons().subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.organizations = res;
      } else if (res.length === 1) {
        this.eventService.setOrganizations(res[ 0 ].id);
        this.getEvents(res[ 0 ].id);
        delete this.filterData.organizations;
      } else {
        delete this.filterData.organizations;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  chooseFilters (e) {
    // console.log(e);
    if (e.choose === 'all') {
      this.fuseConfig.setActiveFilter(false);
      delete this.filterData.cantonFB;
      delete this.filterData.countries;
      delete this.filterData.organizations;
      this.eventService.setToAll();
      this.getCountries();
    } else if (e.choose.hasOwnProperty('country')) {
      delete this.filterData.cantonFB;
      delete this.filterData.organizations;
      this.getCantons(e.choose.country);
      this.eventService.setCountryId(e.choose.country);
      this.fuseConfig.setActiveFilter(true);
    } else if (e.choose.hasOwnProperty('cantonFB')) {
      delete this.filterData.organizations;
      this.eventService.setCity(e.choose.cantonFB);
      this.getOrganizations();
      this.fuseConfig.setActiveFilter(true);
    } else if (e.choose.hasOwnProperty('organization')) {
      this.eventService.setOrganizations(e.choose);
      this.getEvents();
      this.fuseConfig.setActiveFilter(true);
    }
    // this.setDataFromFilter(e);
  }

  getEvents(id?) {
    this.eventService.getEventsBudget(id).subscribe((res: any) => {
      if (res && res.length) {

        this.dataSource = res.map(el => {
          el.expenses = el.material + el.meals + el.transport +
            el.rents + el.miscellaneous;
          el.revenues = (el.participantFriend * el.costFriend) + (el.participant * el.cost);
          el.outlay = +el.expenses - el.revenues;
          this.total = this.total + +el.outlay;
          return el;
        });
      }
    });
  }

}
